// Inline-mounted brand logo sprite.
//
// The `<symbol id="gemini">` definition uses a `<linearGradient>` with a
// URL reference (`fill="url(#geminigrad)"`). When the symbol is consumed
// via `<use href="/logos/sprite-color.svg#gemini" />` (cross-document),
// WebKit (Telegram iOS / Telegram Mac) does not resolve the gradient ID
// inside the external symbol, so the path renders with no fill and the
// cell looks empty. The exact same code works in Chrome.
//
// Fix: ship the sprite once as inline DOM at app boot. After this,
// callers use same-document refs (`#gemini`) which work everywhere.
import { onMount } from "solid-js";
import spriteSrc from "../../public/logos/sprite-color.svg?raw";

export function SpriteInline() {
  let host: HTMLDivElement | undefined;
  onMount(() => {
    if (!host) return;
    // The fetched file is a full `<svg>...</svg>`; setting innerHTML lets
    // the browser parse it as proper SVG namespace and registers the
    // <symbol> ids in this document. Hidden via inline style; aria-hidden
    // already in the file.
    host.innerHTML = spriteSrc;
  });
  return (
    <div
      ref={host}
      aria-hidden="true"
      style={{
        position: "absolute",
        width: "0",
        height: "0",
        overflow: "hidden",
        "pointer-events": "none",
      }}
    />
  );
}
